import { render, staticRenderFns } from "./inputFormToEditActivo.vue?vue&type=template&id=6749147a&"
import script from "./inputFormToEditActivo.vue?vue&type=script&lang=js&"
export * from "./inputFormToEditActivo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports